import { useOutletContext, useSearchParams } from "react-router-dom";

import CreateProductionProducerView from "../views/CreateProductionProducerView/CreateProductionProducerView";

export default function CreateProductionProducer() {
	const [searchParams, setSearchParams] = useSearchParams();
	const { organization } = useOutletContext();

	const articleId = searchParams.get("article");
	const workId = searchParams.get("work");

	return <CreateProductionProducerView organization={organization} articleId={articleId} workId={workId} />;
}
